var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIntel = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_INTEL",
    x: "0px",
    y: "0px",
    width: "114.141px",
    height: "75.271px",
    viewBox: "0 0 114.141 75.271",
    enableBackground: "new 0 0 114.141 75.271",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C5",
    d: "M54.219,67.099c-22.553,2.08-46.063-1.197-49.355-18.824c-1.61-8.689,2.354-17.902,7.605-23.629v-3.059 C3.009,29.882-2.117,40.38,0.834,52.78C4.606,68.685,24.777,77.692,55.573,74.7c12.19-1.18,28.132-5.1,39.223-11.191V54.86 C84.73,60.858,68.086,65.812,54.219,67.099z M113.635,21.38c-5.35-26.119-56.064-27.775-88.756-7.875v2.197 c32.654-16.787,78.973-16.686,83.189,7.375c1.416,7.961-3.068,16.252-11.077,21.025v6.244 C106.626,46.813,116.509,35.382,113.635,21.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C5",
    d: "M92.972,17.575h-5.913v26.34c0,3.086,1.492,5.771,5.913,6.199V17.575z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C5",
    d: "M22.559,27.192h-5.926L16.63,44.399c0,3.1,1.497,5.779,5.929,6.201V27.192z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.633,
    y: 18.378,
    fill: "#C2C2C5",
    width: 5.906,
    height: 5.605
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C5",
    d: "M57.973,50.329c-4.785,0-6.812-3.328-6.812-6.605V20.876h5.862v6.316h4.414v4.736h-4.414v11.434 c0,1.336,0.634,2.08,2.027,2.08h2.387v4.887H57.973"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C5",
    d: "M68.76,40.595c0,3,1.877,5.203,5.195,5.203c2.601,0,3.883-0.721,5.385-2.203l3.623,3.449 c-2.322,2.295-4.756,3.689-9.051,3.689c-5.609,0-10.984-3.061-10.984-11.988c0-7.631,4.695-11.943,10.854-11.943 c6.261,0,9.858,5.049,9.858,11.678v2.115H68.76 M73.525,31.649c-2.006,0-3.548,1.033-4.201,2.428 c-0.381,0.838-0.521,1.49-0.564,2.52h9.035C77.681,34.077,76.539,31.649,73.525,31.649z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C5",
    d: "M38.48,31.929c1.718,0,2.433,0.85,2.433,2.229v16.205h5.863V34.124c0-3.291-1.753-6.924-6.902-6.924 l-12.112-0.008v23.17h5.865V31.929H38.48z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C5",
    d: "M99.336,22.284c-1.305,0-2.345-1.053-2.345-2.355c0-1.295,1.04-2.354,2.345-2.354 c1.297,0,2.361,1.059,2.361,2.354C101.697,21.231,100.633,22.284,99.336,22.284z M99.336,17.968c-1.075,0-1.939,0.891-1.939,1.961 c0,1.08,0.864,1.953,1.939,1.953c1.073,0,1.965-0.873,1.965-1.953C101.301,18.858,100.409,17.968,99.336,17.968z M100.378,21.341 h-0.439c-0.041,0-0.075-0.025-0.089-0.061l-0.596-1.01c-0.019-0.021-0.068-0.047-0.084-0.047c0,0-0.1,0-0.174,0 c-0.042,0-0.082,0-0.099,0v1.008c0,0.049-0.034,0.109-0.099,0.109h-0.396c-0.059,0-0.1-0.061-0.1-0.109V18.69 c0-0.15,0.051-0.211,0.18-0.229c0.143-0.016,0.514-0.035,0.723-0.035c0.733,0,1.164,0.217,1.164,0.896v0.049 c0,0.422-0.207,0.65-0.529,0.752l0.619,1.055c0.01,0.016,0.016,0.053,0.016,0.074C100.475,21.294,100.453,21.341,100.378,21.341z M99.809,19.323c0-0.283-0.176-0.373-0.555-0.373c-0.049,0-0.174,0-0.272,0c-0.043,0-0.084,0-0.103,0v0.807 c0.06,0,0.326,0.012,0.375,0.012c0.379,0,0.555-0.127,0.555-0.396V19.323z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIntel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/intel.f9a645b9.svg";
export { ForwardRef as ReactComponent };